module.exports = __webpack_public_path__ + "static/media/expiiFlyer.f75ba82c.jpg";